<template>
  <div>
        <v-dialog v-model="dialog" hide-overlay max-width="800px">
      <v-btn block slot="activator" color="primary" outline>send selected data<v-icon right >send</v-icon></v-btn>
      <v-card>
        <!-- <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>
            <div v-if="weeklyStats">Sending Weekly Stats</div>
            <div v-else >Sending Daily Stats</div>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click="dialog = false">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar> -->
        <v-list subheader>
          <v-subheader>Report includes</v-subheader>
          <v-list-tile avatar>
            <v-list-tile-action>
              <v-icon color="primary">radio_button_checked</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Daily Stats (Calories, Weight, Steps)</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile avatar v-if="selectedMeasurements.length > 0">
            <v-list-tile-action>
              <v-icon color="primary">radio_button_checked</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Measurements</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <p class="pa-3">
          Sending data from: <strong>{{startDate | calendarShort}}</strong> to: <strong>{{endDate | calendarShort}}</strong>
        </p>
        <v-divider></v-divider>
        <!-- <v-subheader>Report includes</v-subheader> -->
        <v-layout row>
          <v-flex xs12 class="pa-3">
            <v-textarea
              name="message"
              v-model="message"
              label="Additonal Message"
            ></v-textarea>
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="dialog = false">Close</v-btn>
          <v-btn :loading="loadingSave" color="primary" @click.native="submit">
            Submit<v-icon right dark>send</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snack.active"
      bottom
      :timeout="snack.timeout"
    >
      {{snack.text}}
      <v-btn
        color="secondary"
        flat
        @click="snack.active = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import { db } from '@/services/firebase'
export default {
  data () {
    return {
      dialog: false,
      message: '',
      snack: {
        active: false,
        timeout: 3000,
        text: 'Report Sent!',
        color: 'secondary'
      },
      loadingSave: false
    }
  },
  props: [
    'user',
    'stats',
    'endDate',
    'startDate',
    'weeklyStats',
    'selectedMeasurements'
  ],
  methods: {
    submit: function () {
      this.loadingSave = true
      var self = this
      var start = moment(self.startDate).format('YYYY-MM-DD')
      var end = moment(self.endDate).format('YYYY-MM-DD')
      db.collection('user_reports').add({
        user_id: self.$route.params.userId,
        message: self.message,
        daily_stats: self.stats,
        measurements: self.selectedMeasurements,
        start_date: moment(start).unix(),
        end_date: moment(end).unix(),
        weekly_stats: self.weeklyStats,
        sender_name: self.userProfile.name,
        created_at: moment().unix(),
        read_at: null
      })
        .then(function (docRef) {
          var data = {
            id: docRef.id,
            user_id: self.$route.params.userId,
            message: self.message,
            daily_stats: self.stats,
            measurements: self.selectedMeasurements,
            start_date: moment(start).unix(),
            end_date: moment(end).unix(),
            weekly_stats: self.weeklyStats,
            sender_name: self.userProfile.name,
            created_at: moment().unix(),
            read_at: null
          }
          self.$emit('reported', data)
          self.addNofitication(docRef.id)
        })
        .catch(function (error) {
          self.loadingSave = false
          if (error) {
            console.error('Error', error)
          }
        })
    },
    addNofitication (id) {
      var self = this
      db.collection('notifications').add({
        created_at: moment().unix(),
        user_id: self.$route.params.userId,
        sender_id: self.currentUser,
        sender_name: self.userProfile.name,
        feedback_id: null,
        report_id: id,
        read_at: null
      })
        .then(function () {
          self.dialog = false
          self.snack.active = true
          self.loadingSave = false
          self.message = ''
        })
        .catch(function (error) {
          if (error) {
            self.loadingSave = false
            console.error('Error', error)
          }
        })
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      userProfile: 'userProfile'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/partial/stats-share-dialog.vue